import { CustomModalContent, EDEStatementsCustomModal } from "components/custom-ui/CustomModal";
import { FormContainer, FormRowView } from "components/shared";
import "./styles.css";
import "./mobile.css";


/**
 * @function EDEAssociateNoticesModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the EDEAssociateNoticesModal
 */
export default function EDEAssociateNoticesModal(props) {
    const data = props.data.data ?? {};
    const ui = props.data.ui ?? {};
    const account = data.account ?? {};

    return (
        <EDEStatementsCustomModal id="EDEAssociateNoticesModal" title={ `View Associated Notices & Year-End Tax Forms - ${ account.name } - ${ account.number }`} className="ede-statement-modal">
            <CustomModalContent>
                <FormContainer>
                    <FormRowView>
                        <p>
                            <span>{ `No eNotices found.` }</span>
                        </p>
                    </FormRowView>
                </FormContainer>
            </CustomModalContent>
        </EDEStatementsCustomModal>
    );
}
